import React from 'react';
import useLocale from '@/hooks/useLocale';
import type { LocaleWithGatorProtectAAClient } from '../../../gatorProtect.types';
import {
  ProtectionCardRoot,
  ProtectionCardBody,
  ProtectionCardShield,
  ProtectionCardTextBlock,
  ProtectionCardTitle,
  ProtectionCardDescription,
  ProtectionCardActions,
  ProtectionCardButton,
  ProtectionCardMonarx,
} from '../ProtectionCardCompound';

/** Discriminator for forcing `ProtectionCardFactory` into this variant. */
export const AA_CLIENT_PROTECTION_CARD_TYPE = 'aaClient' as const;
export type AAClientProtectionCardType = typeof AA_CLIENT_PROTECTION_CARD_TYPE;

export type AAClientVariantProps = {
  testId?: string;
  hideButtons?: boolean;
  isTrialActive?: boolean;
  onActivateTrial?: () => void;
  onActivateProtectionPro?: () => void;
};

const AAClientVariant = ({
  testId,
  hideButtons = false,
  isTrialActive = false,
  onActivateTrial,
  onActivateProtectionPro,
}: AAClientVariantProps) => {
  const { gatorProtect } = useLocale() as LocaleWithGatorProtectAAClient;
  const aaClient = gatorProtect?.protectionCard?.aaClient;

  const block = isTrialActive ? aaClient?.trialActive : aaClient?.notActivated;

  if (!block) {
    return null;
  }

  const action = block.actions && block.actions[0];
  const onAction = isTrialActive ? onActivateProtectionPro : onActivateTrial;
  const actionsTestId = `${testId}__actions`;

  return (
    <ProtectionCardRoot testId={testId}>
      <ProtectionCardBody>
        <ProtectionCardShield title={block.title} />
        <ProtectionCardTextBlock>
          <ProtectionCardTitle>{block.title}</ProtectionCardTitle>
          <ProtectionCardDescription html={block.description} />
          {!hideButtons && action && (
            <ProtectionCardActions actionsTestId={actionsTestId}>
              <ProtectionCardButton
                variant={action.variant}
                hasMultipleButtons={false}
                onClick={onAction}
                testId={`${testId}__action-${action.key}`}
              >
                {action.label}
              </ProtectionCardButton>
            </ProtectionCardActions>
          )}
        </ProtectionCardTextBlock>
      </ProtectionCardBody>
      <ProtectionCardMonarx title={block.title} />
    </ProtectionCardRoot>
  );
};

export default AAClientVariant;
